var _a;
import { __assign, __spreadArray } from "tslib";
import findIndex from 'lodash/findIndex';
import { STREAM__SET_PARAM, STREAM__FETCH_FAILURE, STREAM__DELETE_ITEMS, STREAM__REPLACE_ITEM, STREAM__MOVE_ITEM, STREAM__INSERT_ITEMS, replaceItems, markAsFetching, markAsCancelled, } from './actions';
export var handleInitAction = function (streamState, action) {
    var streamId = action.streamId, _a = action.streamParams, streamParams = _a === void 0 ? {} : _a, streamType = action.streamType, groupId = action.groupId, itemsPerFetch = action.itemsPerFetch, _b = action.items, items = _b === void 0 ? [] : _b, total = action.total, _c = action.hasMore, hasMore = _c === void 0 ? false : _c, _d = action.hasLess, hasLess = _d === void 0 ? false : _d, fetchNextCallback = action.fetchNextCallback, fetchPreviousCallback = action.fetchPreviousCallback, fetchAllCallback = action.fetchAllCallback;
    return __assign(__assign({}, streamState), { streamId: streamId, streamParams: streamParams, streamType: streamType, groupId: groupId, itemsPerFetch: itemsPerFetch, items: items, total: total, hasMore: hasMore, hasLess: hasLess, 
        // store only the action type as the callback itself doesn't serialize after ssr
        // since the signature is fixed, we can easily re-create the action creators anyway
        fetchNextCallback: fetchNextCallback === null || fetchNextCallback === void 0 ? void 0 : fetchNextCallback.toString(), fetchPreviousCallback: fetchPreviousCallback === null || fetchPreviousCallback === void 0 ? void 0 : fetchPreviousCallback.toString(), fetchAllCallback: fetchAllCallback === null || fetchAllCallback === void 0 ? void 0 : fetchAllCallback.toString() });
};
export var handleFetchAction = function (streamState) { return (__assign(__assign({}, streamState), { isFetching: true })); };
export var handleFetchSuccessAction = function (streamState, action) { return (__assign(__assign({}, streamState), { isFetching: false, items: __spreadArray(__spreadArray([], (streamState.items || []), true), action.items, true), total: action.total !== undefined ? action.total : streamState.total, hasMore: action.hasMore, errorMsg: undefined, fetchFailuresConsecutive: 0 })); };
export var handleFetchPreviousSuccessAction = function (streamState, _a) {
    var _b = _a.payload, items = _b.items, _c = _b.dedupeFunction, dedupeFunction = _c === void 0 ? function () { return true; } : _c, hasLess = _b.hasLess;
    var dedupedItems = items.filter(function (item) {
        return dedupeFunction(item, streamState.items);
    });
    if (!dedupedItems.length) {
        return __assign(__assign({}, streamState), { fetchFailuresConsecutive: 0 });
    }
    return __assign(__assign({}, streamState), { isFetching: false, fetchFailuresConsecutive: 0, items: __spreadArray(__spreadArray([], dedupedItems, true), streamState.items, true), hasLess: hasLess });
};
export var handleFetchAllSuccessAction = function (streamState, _a) {
    var items = _a.payload.items;
    return __assign(__assign({}, streamState), { isFetching: false, fetchFailuresConsecutive: 0, items: items, hasLess: false, hasMore: false });
};
export var handleFetchFailureAction = function (streamState, action) { return (__assign(__assign({}, streamState), { isFetching: false, errorMsg: action.errorMsg, fetchFailuresConsecutive: (streamState.fetchFailuresConsecutive || 0) + 1 })); };
export var handleDeleteItemsAction = function (streamState, action) {
    var _a, _b;
    var items = (_a = streamState.items) !== null && _a !== void 0 ? _a : [];
    var isEqual = (_b = action.isEqual) !== null && _b !== void 0 ? _b : (function (a, b) { return a === b; });
    var updatedItems = items.filter(function (item) { return !action.items.some(function (i) { return isEqual(item, i); }); });
    var removedCount = items.length - updatedItems.length;
    var updatedTotal = (streamState.total || 0) - removedCount;
    return __assign(__assign({}, streamState), { items: updatedItems, total: updatedTotal > 0 ? updatedTotal : 0 });
};
export var handleMoveItemAction = function (streamState, action) {
    var items = streamState.items;
    var position = action.position, item = action.item;
    var itemPosition = items.indexOf(item);
    if (itemPosition === position) {
        return streamState;
    }
    var updatedItems = __spreadArray([], items, true);
    updatedItems.splice(itemPosition, 1);
    updatedItems.splice(position, 0, item);
    return __assign(__assign({}, streamState), { items: updatedItems });
};
export var handleReplaceItemAction = function (streamState, action) {
    var itemIndex = findIndex(streamState.items || [], action.predicate);
    if (itemIndex === -1) {
        return streamState;
    }
    var newItems = __spreadArray([], streamState.items, true);
    newItems[itemIndex] = action.newItem;
    return __assign(__assign({}, streamState), { items: newItems });
};
export var handleInsertItemsAction = function (streamState, action) {
    var sorted = action.newItems.slice();
    sorted.sort(function (a, b) {
        if (a.offset === b.offset) {
            return 0;
        }
        return a.offset > b.offset ? 1 : -1;
    });
    var newItems = __spreadArray([], streamState.items, true);
    var inserted = 0;
    for (var _i = 0, sorted_1 = sorted; _i < sorted_1.length; _i++) {
        var elem = sorted_1[_i];
        if (action.deduplicate && newItems.includes(elem.item)) {
            continue;
        }
        inserted++;
        var offset = Math.max(elem.offset, 0);
        if (offset >= newItems.length) {
            newItems.push(elem.item);
        }
        else {
            newItems.splice(offset, 0, elem.item);
        }
    }
    return __assign(__assign({}, streamState), { total: (streamState.total || 0) + inserted, items: newItems });
};
export var handleSetParam = function (streamState, action) {
    var _a;
    return (__assign(__assign({}, streamState), { streamParams: __assign(__assign({}, streamState.streamParams), (_a = {}, _a[action.paramType] = action.paramValue, _a)) }));
};
export var handleReplaceItems = function (streamState, _a) {
    var updatedItems = _a.payload.updatedItems;
    return (__assign(__assign({}, streamState), { items: updatedItems }));
};
export var handleMarkAsFetching = function (streamState, action) { return (__assign(__assign({}, streamState), { isFetching: true })); };
export var handleMarkAsCancelled = function (streamState, action) { return (__assign(__assign({}, streamState), { isFetching: false })); };
export var handleEmptyStream = function (streamState, action) { return (__assign(__assign({}, streamState), { isFetching: false, items: [], total: 0, hasMore: false, hasLess: false, fetchFailuresConsecutive: 0 })); };
export var handleResetStream = function (streamState, action) { return (__assign(__assign({}, streamState), { isFetching: false, items: [], hasMore: true, hasLess: false, fetchFailuresConsecutive: 0 })); };
// installed to reducer of every stream type as they are
export var commonActionHandlers = (_a = {},
    _a[STREAM__FETCH_FAILURE] = function (streamState, action) { return handleFetchFailureAction(streamState, action); },
    _a[STREAM__MOVE_ITEM] = function (streamState, action) { return handleMoveItemAction(streamState, action); },
    _a[STREAM__DELETE_ITEMS] = function (streamState, action) { return handleDeleteItemsAction(streamState, action); },
    _a[STREAM__REPLACE_ITEM] = function (streamState, action) { return handleReplaceItemAction(streamState, action); },
    _a[STREAM__SET_PARAM] = function (streamState, action) { return handleSetParam(streamState, action); },
    _a[STREAM__INSERT_ITEMS] = function (streamState, action) { return handleInsertItemsAction(streamState, action); },
    _a[replaceItems.toString()] = handleReplaceItems,
    _a[markAsFetching.toString()] = handleMarkAsFetching,
    _a[markAsCancelled.toString()] = handleMarkAsCancelled,
    _a);
//# sourceMappingURL=actionHandlers.js.map